var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 20L109 20","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M89.4976 39.9951L108.995 20.4976L89.4976 1","stroke":"black","strokeWidth":"2","key":1})]);
}

ArrowInline.defaultProps = {"width":"111","height":"41","viewBox":"0 0 111 41","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
